import React, { FC } from 'react';
import styles from './header_logo_image.module.scss';

export const HeaderLogoImage: FC = () => <span className={styles.logoImage} />;
